'use client';

import { twJoin } from 'tailwind-merge';
import {
  usePathname,
  useRouter,
  useSelectedLayoutSegments,
} from 'next/navigation';
import { GridLayout, Divider } from '@wishket/design-system';
import { useEffect } from 'react';

import UserMenu from './UserMenu';
import MobileTopBar from './MobileTopBar';

import { useDeviceCheck } from '@/shared/hooks';
import {
  MainMenu,
  SubNavigationBar,
  ServiceNavigationBar,
} from '@/features/AppBar';
import { ClientAuth } from '@/shared/auth';

interface Category {
  name: string;
  flag: string;
  ogTitle: string;
  ogDescription: string;
  ogImage: string;
}

interface AppBarRouterProps {
  isAuth: boolean;
  categoryList: Category[];
}

const AppBarRouter = ({ isAuth, categoryList }: AppBarRouterProps) => {
  const segments = useSelectedLayoutSegments();
  const { isDesktop } = useDeviceCheck();
  const router = useRouter();
  const pathname = usePathname();
  const isMobileTopBar = segments.includes('(authorized)') && !isDesktop;
  const isFixedTopBar = segments[2] !== 'detail';

  useEffect(() => {
    const refreshAppBar = async () => {
      const accessToken = await ClientAuth.getAccessToken();

      if (!accessToken) router.refresh();
    };

    refreshAppBar();
  }, [router, pathname]);

  return (
    <header
      className={twJoin(
        'box-border w-full bg-w-white',
        isFixedTopBar && 'fixed left-0 top-0 z-[25]'
      )}
    >
      {isMobileTopBar ? (
        <MobileTopBar />
      ) : (
        <>
          <ServiceNavigationBar />
          <GridLayout>
            <nav className="box-border flex items-center justify-between gap-4 grid-in-content">
              <MainMenu />
              <UserMenu isAuth={isAuth} />
            </nav>
          </GridLayout>
          <GridLayout gridTemplateAreaClass="block desktop:grid grid-areas-default-mobile tablet:grid-areas-default-tablet px-0 desktop:grid-areas-default-desktop">
            <SubNavigationBar categoryList={categoryList} />
          </GridLayout>
          <Divider />
        </>
      )}
    </header>
  );
};

export default AppBarRouter;
